<aside class="sidebar">
  <header class="sidebar-header">
    <span class="sidebar-title ui-label">Online now</span>
    <span class="count-pill">{{ onlineCount() }}</span>
  </header>

  <div class="sidebar-toolbar">
    <input
      type="text"
      class="sidebar-search"
      name="sidebarSearch"
      placeholder="Search player…"
      [value]="searchText()"
      (input)="searchText.set($any($event.target).value)"
    />
  </div>

  <div class="list">
    @if (selfAddress() && !searchText().trim()) {
      <app-online-player-row
        [address]="selfAddress()!"
        [player]="selfUser()"
        [isSelf]="true"
        (toggle)="editSelf.emit()"
      ></app-online-player-row>
    }

    @for (entry of visibleOthers(); track entry.address) {
      <app-online-player-row
        [address]="entry.address"
        [player]="entry.user"
        [defaultMode]="defaultMode()"
        [pendingAddress]="challengePending()"
        [openProfileOnClick]="true"
        (challenge)="challenge.emit($event)"
      ></app-online-player-row>
    }
  </div>
</aside>
